import React, { useMemo } from 'react';
import styled from 'styled-components';
import qs from 'qs';
import { FormattedMessage } from 'react-intl';
import { Row, Space } from 'antd';
import { useLocation } from 'react-router';

import OpenPageBase from 'Common/pages/OpenPageBase';
import ResetPasswordContainer from '../components/ResetPassword';

const Title = styled.h1`
  font-size: 24px;
`;

const ContentWrapper = styled.div`
  background: #fff;
  padding: 50px;
  width: min-content;
  min-width: 350px;
`;

const EmptyTokenMessage = (
  <Title>
    <FormattedMessage
      defaultMessage="This session expired or you link is not valid. Please request a new link <link>here</link>"
      values={{
        link: (text: React.ReactNode) => <a href="/forgot-password">{text}</a>,
      }}
    />
  </Title>
);

const ResetPassword = () => {
  const location = useLocation();
  const { search } = location;
  const query = useMemo(
    () => qs.parse(search, { ignoreQueryPrefix: true }),
    [search]
  );

  return (
    <OpenPageBase>
      <Row css="height: 100%" justify="center" align="middle">
        {!query.token ? (
          EmptyTokenMessage
        ) : (
          <ContentWrapper>
            <Space orientation="vertical" css="width: 100%">
              <Title>
                <FormattedMessage defaultMessage="Reset your password" />
              </Title>
              <ResetPasswordContainer token={String(query.token)} />
              <div css="text-align: center">
                <FormattedMessage
                  defaultMessage="Already have an account? <link>Sign in</link>"
                  values={{
                    link: (chunk: React.ReactNode) => (
                      <a href="/login">{chunk}</a>
                    ),
                  }}
                />
              </div>
            </Space>
          </ContentWrapper>
        )}
      </Row>
    </OpenPageBase>
  );
};

export default ResetPassword;
